import { render, staticRenderFns } from "./IcmAcademyModal.vue?vue&type=template&id=4ca8028a"
import script from "./IcmAcademyModal.vue?vue&type=script&lang=js"
export * from "./IcmAcademyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports